import { format, parseISO } from 'date-fns';
import { es } from 'date-fns/locale';

export const formatDate = (dateString) => {
    return format(parseISO(dateString), "dd MMM", { locale: es });
};